import script from "./FooterView.vue?vue&type=script&setup=true&lang=ts"
export * from "./FooterView.vue?vue&type=script&setup=true&lang=ts"

import "./FooterView.vue?vue&type=style&index=0&id=73efb7f6&lang=scss&scoped=true"

import exportComponent from "/data/.jenkins/workspace/Shita-erp-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73efb7f6"]])

export default __exports__